module.exports = __webpack_public_path__ + "img/login-icon.6527e560.svg";